import { SvgIcon, type SvgIconProps } from './svgIcon'

export const SecuredInvestmentIcon = ({
  width = 16,
  height = 16,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <rect
      y="0.307617"
      width="15.3846"
      height="15.3846"
      rx="7.69231"
      fill="#50F000"
    />
    <path
      d="M11.111 5.43652L6.55039 10.5647L4.27344 8.36507"
      stroke="#121212"
      strokeWidth="1.53846"
      strokeMiterlimit="10"
    />
  </SvgIcon>
)
